export const convertCentsToDollar = (cents) => {
  const results = cents / 100
  return results
}
